import React from 'react';
import { Stack, Typography } from '@mui/material';

import ChildCard from 'src/components/shared/ChildCard';
import {
  IconBallTennis,
  IconBell,
  IconEye,
  IconList,
  IconTournament,
  IconTrophy,
} from '@tabler/icons';
import { AppState, useSelector } from 'src/store/Store';
import useLang from 'src/hooks/useLang';
import useMoment from 'src/views/pages/schedule/hooks/useMoment';
import { t } from 'i18next';

const IntroCard = () => {
  const selectedTournament = useSelector((state) => state.tournamentReducer.selectedTournament);

  const options = useSelector((state: AppState) => state.tournamentReducer.options);

  return (
    <ChildCard sx={{ padding: 0, borderColor: (theme: any) => theme.palette.divider, mt: 2 }}>
      <Typography fontWeight={600} variant="h4" mb={4}>
        {t('TournamentProfile.config')}
      </Typography>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconBallTennis size={21} />
        <Typography variant="h6">{`${t('TournamentsScreen.withGoldenPoint')}: ${
          selectedTournament?.is_golden_point ? t('Common.yes') : t('Common.no')
        }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconTournament size="21" />
        <Typography variant="h6">{`${t('TournamentsScreen.interfaceType')}: ${
          options?.data?.interface_types[selectedTournament?.interface_type]
        }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconTrophy size="21" />
        <Typography variant="h6">{`${t('TournamentsScreen.withThirdSetTieBreaker')}: ${
          selectedTournament?.is_third_set_tie_breaker ? t('Common.yes') : t('Common.no')
        }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconEye size="21" />
        <Typography variant="h6">{`${t('TournamentsScreen.showTeams')}: ${
          selectedTournament?.config?.show_teams === 0 ? t('Common.no') : t('Common.yes')
        }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconBell size="21" />
        <Typography variant="h6">{`${t('TournamentsScreen.scheduleNotifications')}: ${
          selectedTournament?.config?.schedule_notifications === 0
            ? t('Common.no')
            : t('Common.yes')
        }`}</Typography>
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" mb={4}>
        <IconList size="21" />
        <Typography variant="h6">{`${t('TournamentsScreen.withWaitingList')}: ${
          selectedTournament?.is_waiting_list ? t('Common.yes') : t('Common.no')
        }`}</Typography>
      </Stack>
    </ChildCard>
  );
};

export default IntroCard;
